import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { mascaraCelular9Digito, formataDataDDMMYYYYParaHTML5, formataDataHTML5ParaDDMMYYYY } from '../../modules/util';
import CONSTANTS from '../../constants';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import api from '../../modules/api';
export default class FormPessoa extends React.Component {

    static defaultProps = {
        campoErros: {},

        listCidades: []
    };

    componentDidMount() {

    }

    changeCampoGenericoFiador(campoState, valor) {
        this.props.changeCampoGenericoFiador(campoState, valor, this.props.tipoPessoa, this.props.indiceFiador);
    }

    onContinuarCPF() {
        this.props.onContinuarCPF(this.props.pesCPF, this.props.tipoPessoa, this.props.indiceFiador);
    }

    onEditarFiadorCPF() {
        this.props.onEditarFiadorCPF(this.props.tipoPessoa, this.props.indiceFiador);
    }

    onConsultaFiadorCEP(cep) {
        this.props.onConsultaFiadorCEP(cep, this.props.tipoPessoa, this.props.indiceFiador);
    }

    onChangeFiadorUF(uf) {
        this.props.onChangeFiadorUF(uf, this.props.tipoPessoa, this.props.indiceFiador);
    }

    render() {
        var cpf = (
            <div style={{
                textAlign: 'center',
                backgroundColor: '#fff'
            }}>
                <FormControl className='item-form'
                    style={{
                        textAlign: "center"
                    }}>
                    <TextField
                        error={this.props.campoErros.pesCPF}
                        type="number"
                        style={{ width: "150px" }}
                        id="pes-cpf"
                        label="CPF"
                        value={this.props.pesCPF > 0 ? this.props.pesCPF : ""}
                        onChange={(e) => this.changeCampoGenericoFiador('pesCPF', e.target.value)}
                        margin="normal"
                        helperText={"Somente números"}

                    />
                    <Button
                        disabled={this.props.bloquearTudo || this.props.carregandoPessoaCPF}
                        onClick={(e) => this.onContinuarCPF()}
                        variant="raised" color="primary" >
                        Continuar
                    </Button>
                </FormControl>
            </div>
        );

        var msgDadosJaCadastrado = "Dados cadastrais estão de acordo com o seu registro na Unoeste. Caso haja algum erro, por favor, procure o Departamento Pessoal para realizar a atualização.";
        var divMsgCadastroExiste = (
            <div
                className=""
                style={{
                    margin: "20px  0",
                    border: "1px solid #ccc",
                    padding: "20px",
                    backgroundColor: "rgb(255, 254, 209)"
                }}>
                <Typography variant="caption" gutterBottom align="center">
                    {msgDadosJaCadastrado}
                </Typography>
            </div>
        );
        var msgDadosBloqueado = "Não é possível alterar os dados deste cadastro! [" + this.props.formTitulo + "]";
        var divMsgDadosBloqueado = (
            <div
                className=""
                style={{
                    margin: "20px  0",
                    border: "1px solid #ccc",
                    padding: "20px",
                    backgroundColor: "rgb(255, 254, 209)"
                }}>
                <Typography variant="caption" gutterBottom align="center">
                    {msgDadosBloqueado}
                </Typography>
            </div>
        );
        //======BASICO=========================================================================================
        let formDadosBasicos = (
            <fieldset>
                <legend>Dados Básicos</legend>
                <div>
                    <FormControl className='item-form'
                        style={{
                            textAlign: "center"
                        }}>
                        <TextField
                            type="number"
                            disabled={true}
                            style={{ width: "170px" }}
                            id="pes-cpf"
                            label="CPF"
                            value={this.props.pesCPF > 0 ? this.props.pesCPF : ""}
                            onChange={(e) => this.changeCampoGenericoFiador('pesCPF', e.target.value)}
                            margin="normal"
                            InputProps={{
                                endAdornment: <InputAdornment position="end"> <IconButton disabled={this.props.bloquearTudo} onClick={(e) => this.onEditarFiadorCPF()} variant="fab" size="small" title="Editar"><EditIcon /></IconButton ></InputAdornment>,
                            }}
                        />
                    </FormControl>
                </div>


                <FormControl className='item-form' style={{ width: "10%", minWidth: "150px" }}  >
                    <InputLabel htmlFor='nacCodigo'>Nacionalidade</InputLabel>
                    <Select

                        id='nacCodigo'
                        error={this.props.campoErros.nacCodigo}

                        disabled={this.props.bloquearTudo || this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                        value={this.props.nacCodigo}
                        onChange={(e) => this.changeCampoGenericoFiador('nacCodigo', e.target.value)}
                    >
                        {this.props.listNacionalidade.map((item) => {
                            return (
                                <MenuItem key={item.nac_codigo} value={item.nac_codigo}>{item.nac_descricao}</MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>

                <FormControl className='item-form' style={{ width: "40%", minWidth: "320px" }} >
                    <TextField
                        error={this.props.campoErros.pesNome}
                        disabled={this.props.bloquearTudo || this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                        type="text"
                        fullWidth
                        id="pes-nome"
                        label="Nome"
                        value={this.props.pesNome}
                        onChange={(e) => this.changeCampoGenericoFiador('pesNome', e.target.value)}
                        margin="normal"
                    />
                </FormControl>
                <FormControl className='item-form' style={{ width: "15%", minWidth: '150px' }}  >
                    <TextField
                        error={this.props.campoErros.pesDtNasc}
                        disabled={this.props.bloquearTudo || this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                        type="date"
                        fullWidth
                        id="pesDtNasc"
                        label="Data de Nascimento"
                        value={formataDataDDMMYYYYParaHTML5(this.props.pesDtNasc) || '0000-00-00'}
                        onChange={(e) => { this.changeCampoGenericoFiador('pesDtNasc', formataDataHTML5ParaDDMMYYYY(e.target.value)); }}
                        margin="normal"
                    />
                </FormControl>
                <div>
                    <FormControl className='item-form' style={{ width: "10%", minWidth: "120px" }}  >
                        <TextField
                            error={this.props.campoErros.pesRG}
                            disabled={this.props.bloquearTudo || this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            type="text"
                            fullWidth
                            id="pes-rg"
                            label="RG"
                            value={this.props.pesRG}
                            onChange={(e) => this.changeCampoGenericoFiador('pesRG', e.target.value)}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className='item-form' style={{ width: "10%", minWidth: "120px" }}  >
                        <TextField
                            InputProps={{ maxLength: 10 }}
                            error={this.props.campoErros.pesOrgExp}
                        
                            type="text"
                            fullWidth
                            placeholder="SSP"
                            label="Org. Expedidor "
                            value={this.props.pesOrgExp}
                            onChange={(e) => this.changeCampoGenericoFiador('pesOrgExp', e.target.value)}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className='item-form' style={{ width: "10%", minWidth: "150px" }}  >
                        <InputLabel htmlFor='pesEstExp'>Estado Expedidor</InputLabel>
                        <Select
                            id='pesEstExp'
                            error={this.props.campoErros.pesEstExp}

                            disabled={this.props.bloquearTudo || this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            value={this.props.pesEstExp}
                            onChange={(e) => this.changeCampoGenericoFiador('pesEstExp', e.target.value)}
                        >
                            {api.getEstados().map((item) => {
                                return (
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                    <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                        <TextField
                            error={this.props.campoErros.pesTelefone}
                         
                            type="text"
                            fullWidth
                            placeholder="(00)0000-0000"
                            id="pes-telefone"
                            label="Telefone Fixo"
                            value={mascaraCelular9Digito(this.props.pesTelefone)}
                            onChange={(e) => this.changeCampoGenericoFiador('pesTelefone', mascaraCelular9Digito(e.target.value))}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                        <TextField
                            error={this.props.campoErros.pesCelular}
                         
                            type="text"
                            fullWidth
                            placeholder="(00)00000-0000"
                            id="pes-celular"
                            label="Celular"
                            value={mascaraCelular9Digito(this.props.pesCelular)}
                            onChange={(e) => this.changeCampoGenericoFiador('pesCelular', mascaraCelular9Digito(e.target.value))}
                            margin="normal"
                        />
                    </FormControl>

                    <FormControl className='item-form' >
                        <InputLabel >Sexo</InputLabel>
                        <Select
                            error={this.props.campoErros.pesSexo}
                            disabled={this.props.bloquearTudo || this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                            style={{ width: "200px" }}
                            value={(this.props.pesSexo || '0')}
                            onChange={(e) => this.changeCampoGenericoFiador('pesSexo', e.target.value)}
                        >
                            <MenuItem value={'0'}>--Selecione--</MenuItem>
                            <MenuItem value={'1'}>Masculino</MenuItem>
                            <MenuItem value={'2'}>Feminino</MenuItem>
                        </Select>
                    </FormControl>



                </div>
            </fieldset>
        );
        //======/BASICO==========================================================================================
        //======ENDERECO=========================================================================================
        let formEndereco = (
            <fieldset>
                <legend>Endereço</legend>

                <FormControl className='item-form' style={{ width: "12%", minWidth: "120px" }}  >
                    <TextField
                        error={this.props.campoErros.pesCEP}
                        disabled={this.props.bloquearTudo || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                        onBlur={(e) => { this.onConsultaFiadorCEP(e.target.value) }}
                        type="text"
                        fullWidth
                        placeholder="00000-000"
                        id="pes-cep"
                        label="CEP"
                        value={this.props.pesCEP}
                        onChange={(e) => this.changeCampoGenericoFiador('pesCEP', e.target.value)}
                        margin="normal"
                    />
                    {this.props.carregandoCEP ? <LinearProgress /> : null}
                </FormControl>
                <FormControl className='item-form' style={{ width: "40%", minWidth: "320px" }}  >
                    <TextField
                        error={this.props.campoErros.pesRua}
                        disabled={this.props.bloquearTudo || this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                        type="text"
                        fullWidth
                        id="pesRua"
                        label="Endereço"
                        value={(this.props.pesRua)}
                        onChange={(e) => this.changeCampoGenericoFiador('pesRua', (e.target.value))}
                        margin="normal"
                        helperText={"Ex: Rua Fulano de Tal, 999 - Apt. 999"}
                    />
                </FormControl>
                <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                    <TextField
                        error={this.props.campoErros.pesBairro}
                        disabled={this.props.bloquearTudo || this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido}
                        type="text"
                        fullWidth
                        id="pes-bairro"
                        label="Bairro"
                        value={(this.props.pesBairro)}
                        onChange={(e) => this.changeCampoGenericoFiador('pesBairro', (e.target.value))}
                        margin="normal"
                    />
                </FormControl>
                <FormControl
                    className='item-form' >
                    <InputLabel >Estado</InputLabel>
                    <Select
                        error={this.props.campoErros.uf}
                        style={{ width: "120px" }}
                        disabled={this.props.bloquearTudo || this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido || this.props.carregandoCidades}
                        value={this.props.uf}
                        onChange={(e) => this.onChangeFiadorUF(e.target.value)}
                    >
                        {api.getEstados().map((item) => {
                            return (
                                <MenuItem key={item} value={item}>{item}</MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
                <FormControl style={{ width: "40%", minWidth: "220px" }}
                    className='item-form' >
                    <InputLabel >Cidade</InputLabel>


                    <Select
                        error={this.props.campoErros.locCodigo}
                        disabled={this.props.bloquearTudo || this.props.carregandoCEP || this.props.permissaoAlterar === CONSTANTS._PERMISSAO.naoPermitido || this.props.carregandoCidades}
                        native
                        style={{}}
                        value={this.props.locCodigo || "0"}
                        onChange={(e) => this.changeCampoGenericoFiador('locCodigo', e.target.value)}
                    >
                        <option value="0" >--SELECIONE--</option>
                        {this.props.listCidades.map((item) => {
                            return (
                                <option style={{ backgroundColor: "#fff" }} key={item.loc_codigo} value={item.loc_codigo}>{item.loc_nome.trim()}</option>
                            );
                        })}
                    </Select>
                </FormControl>
            </fieldset>
        );
        //======/ENDERECO=========================================================================================
        //======MORADIA=========================================================================================       
        let formMoradia = (
            <fieldset>
                <legend>Condições de Moradia</legend>
                <FormControl className='item-form' >
                    <InputLabel htmlFor="tipSeq">Condições de Moradia (Residência)</InputLabel>

                    <Select
                        disabled={this.props.bloquearTudo}
                        error={this.props.campoErros.tipSeq}
                        style={{ width: "300px" }}
                        value={this.props.tipSeq || '0'}
                        onChange={(e) => this.changeCampoGenericoFiador("tipSeq", e.target.value)}
                        inputProps={{
                            id: 'tipSeq'
                        }}
                    >
                        <MenuItem value={0}>--SELECIONE--</MenuItem>
                        {this.props.listTpMoradia.map((item, indice) => {
                            return (
                                <MenuItem key={indice} value={item.tip_seq}>{item.tip_descricao}</MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </fieldset>
        );
        //======/MORADIA=========================================================================================        
        //======EMPRESA==========================================================================================
        let formEmpresa = (
            <fieldset>
                <legend>Empresa onde trabalha e/ou Renda Mensal</legend>
                <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                    <TextField
                        disabled={this.props.bloquearTudo}
                        type="text"
                        fullWidth
                        id="pesEmpresa"
                        label="Empresa onde trabalha"
                        value={(this.props.pesEmpresa || "")}
                        onChange={(e) => this.changeCampoGenericoFiador('pesEmpresa', (e.target.value))}
                        margin="normal"
                    />
                </FormControl>
                <FormControl className='item-form' style={{ width: "15%", minWidth: '150px' }}  >
                    <TextField
                        disabled={this.props.bloquearTudo}
                        type="date"
                        fullWidth
                        id="pesDtAdmissao"
                        label="Data de Admissão"
                        value={formataDataDDMMYYYYParaHTML5(this.props.pesDtAdmissao) || '0000-00-00'}
                        onChange={(e) => this.changeCampoGenericoFiador('pesDtAdmissao', formataDataHTML5ParaDDMMYYYY(e.target.value))}
                        margin="normal"
                    />
                </FormControl>
                <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                    <TextField
                        disabled={this.props.bloquearTudo}
                        type="text"
                        fullWidth
                        id="pesCargo"
                        label="Cargo/Profissão"
                        value={(this.props.pesCargo || "")}
                        onChange={(e) => this.changeCampoGenericoFiador('pesCargo', (e.target.value))}
                        margin="normal"
                    />
                </FormControl>
                <FormControl className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                    <InputLabel htmlFor="pesRendaBruta">Renda pessoal bruta mensal</InputLabel>
                    <Input
                        disabled={this.props.bloquearTudo}
                        type="text"
                        fullWidth
                        id="pesRendaBruta"
                        placeholder="00,00"
                        value={(this.props.pesRendaBruta && this.props.pesRendaBruta.toString().replace(/\./gim, ",") || "")}
                        onChange={(e) => this.changeCampoGenericoFiador('pesRendaBruta', (e.target.value))}
                        startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                    />
                </FormControl>
            </fieldset>
        );
        //======/EMPRESA============================================================================================       
        //======ESTADO_CIVTL========================================================================================
        let formEstadoCivil = (
            <fieldset >
                <legend>Estado Civil</legend>
                <FormControl className='item-form' style={{ minWidth: "300px" }} >
                    <InputLabel htmlFor="pesEstCiv"> Estado civil    </InputLabel>
                    <Select
                        fullWidth
                        error={this.props.campoErros.pesEstCiv}
                        disabled={this.props.bloquearTudo || this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo}
                        value={this.props.pesEstCiv}
                        onChange={(e) => this.changeCampoGenericoFiador('pesEstCiv', e.target.value)}
                    >
                        <MenuItem value={0}>--Selecione--</MenuItem>
                        <MenuItem value={1}>  Solteiro</MenuItem>
                        <MenuItem value={2}>  Casado</MenuItem>
                        <MenuItem value={3}>  Viúvo</MenuItem>
                        <MenuItem value={4}>  Divorciado</MenuItem>
                        <MenuItem value={5}>  Desquitado</MenuItem>
                        <MenuItem value={6}>  Outro</MenuItem>
                    </Select>
                </FormControl>
            </fieldset>
        );
        //======/ESTADO_CIVTL========================================================================================
        //======FORMCONJUGE==========================================================================================
        let formConjuge = (
            <div
                className='conjuge'
                style={{

                    display: this.props.pesEstCiv == 2 ? "block" : "none",

                }}>
                <FormPessoa
                    {...this.props.conjuge}
                    listNacionalidade={this.props.listNacionalidade}
                    bloquearTudo={this.props.bloquearTudo}
                    listTpMoradia={this.props.listTpMoradia}
                    indiceFiador={this.props.indiceFiador}
                    changeCampoGenericoFiador={this.props.changeCampoGenericoFiador}
                    onContinuarCPF={this.props.onContinuarCPF}
                    onEditarFiadorCPF={this.props.onEditarFiadorCPF}
                    formTitulo={'Dados do Conjuge ' + (this.props.tipoPessoa === CONSTANTS._TIPO_PESSOA.FIADOR ? '(Fiador ' + (this.props.indiceFiador + 1) + ')' : ' do Responsável')}
                    tipoPessoa={CONSTANTS._TIPO_PESSOA.CONJUGE}
                />
            </div>
        );
        //======/FORMCONJUGE========================================================================================        
        //==========================================================================================================
        //=====FORMDADOSCOMPLETO====================================================================================
        var formDadosCompleto = (
            <div>
                {this.props.bloquearTudo ? divMsgDadosBloqueado : null}
                {this.props.permissaoAlterar !== CONSTANTS._PERMISSAO.tudo ? divMsgCadastroExiste : null}
                {formDadosBasicos}
                {this.props.tipoPessoa !== CONSTANTS._TIPO_PESSOA.CONJUGE ? formEndereco : null}
                {this.props.tipoPessoa !== CONSTANTS._TIPO_PESSOA.CONJUGE ? formMoradia : null}
                {formEmpresa}
                {this.props.tipoPessoa !== CONSTANTS._TIPO_PESSOA.CONJUGE ? formEstadoCivil : null}
                {this.props.tipoPessoa !== CONSTANTS._TIPO_PESSOA.CONJUGE ? formConjuge : null}
            </div>
        );
        //=====/FORMDADOSCOMPLETO==================================================================================

        if (this.props.cpfOK) {
            cpf = null;
        } else {
            formDadosCompleto = null;
        }
        return (
            <div>
                <fieldset style={{ position: "relative" }} >
                    <legend>{this.props.formTitulo}</legend>
                    {this.props.carregando ? <LinearProgress color="primary" /> : null}
                    {this.props.btnRemover ? this.props.btnRemover : null}
                    {cpf}
                    {formDadosCompleto}
                </fieldset>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/fiadores/form-pessoa.js